import React from 'react';
import RandomQuote from '../../Components/RandomQuote/RandomQuote';
import ProjectOverview from '../../Components/ProjectOverview/ProjectOverview';


export default class Home extends React.Component {

    render(){
        return (
            <React.Fragment>
                <RandomQuote />
                <ProjectOverview showAmount={3}  />
            </React.Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Pages/Home/Home.js